module.exports = __webpack_public_path__ + "assets/media/day4.c8d7c3a8.mp3";